import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { AuthContext } from '../App';
import { Activity } from 'lucide-react';

export const ActivityFeed = () => {
  const { API } = useContext(AuthContext);
  const [items, setItems] = useState([]);

  const fetchFeed = () => {
    axios.get(`${API}/activity-feed`)
      .then((res) => setItems(res.data.items || []))
      .catch(() => {});
  };

  useEffect(() => {
    fetchFeed();
    const interval = setInterval(fetchFeed, 60000);
    return () => clearInterval(interval);
  }, []);

  const timeAgo = (iso) => {
    const mins = Math.floor((Date.now() - new Date(iso).getTime()) / 60000);
    if (mins < 1) return 'עכשיו';
    if (mins < 60) return `לפני ${mins} דק׳`;
    if (mins < 1440) return `לפני ${Math.floor(mins / 60)} שע׳`;
    const days = Math.floor(mins / 1440);
    if (days < 30) return `לפני ${days} ימים`;
    return `לפני ${Math.floor(days / 30)} חוד׳`;
  };

  if (items.length === 0) return null;

  return (
    <div className="relative mt-12 overflow-hidden rounded-3xl shadow-2xl" data-testid="activity-feed-section">
      <div className="absolute inset-0 bg-gradient-to-br from-slate-50 via-blue-50/60 to-white"></div>
      <div className="absolute -top-32 -right-32 w-96 h-96 bg-blue-300/20 rounded-full blur-3xl"></div>

      <div className="relative z-10 p-6 sm:p-8">
        <div className="flex items-center gap-3 mb-5">
          <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-green-500 rounded-2xl flex items-center justify-center shadow-lg">
            <Activity className="w-6 h-6 text-white" />
          </div>
          <div>
            <h2 className="text-2xl sm:text-3xl font-black text-gray-900 flex items-center gap-2">
              מה קורה בקהילה
              <span className="relative flex h-3 w-3">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500"></span>
              </span>
            </h2>
            <p className="text-gray-500 text-sm">עדכונים חיים — משחקים, הרשמות וחברים חדשים</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-2.5">
          {items.slice(0, 10).map((item, i) => {
            const inner = (
              <div className="flex items-center gap-3 bg-white/80 backdrop-blur rounded-2xl px-4 py-3 border border-slate-100 hover:border-blue-200 hover:shadow-md transition-all" data-testid={`activity-item-${i}`}>
                <span className="text-2xl shrink-0">{item.icon}</span>
                <p className="text-sm font-semibold text-gray-700 leading-snug flex-1 truncate">{item.text}</p>
                <span className="text-[11px] text-gray-400 whitespace-nowrap shrink-0">{timeAgo(item.ts)}</span>
              </div>
            );
            return item.link ? (
              <Link key={i} to={item.link}>{inner}</Link>
            ) : (
              <div key={i}>{inner}</div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
